module.exports = __webpack_public_path__ + "static/carBronze2-b865ad2656a20eae99006965f12a466a.png";